/**
 * Rozyx Vision gate: a usable principal must have a non-empty account_id and the
 * account_type must be 'builder'. Rowi admins bypass this check in the engine —
 * everyone else gets login-only (blocked screen), per the implementation strategy.
 *
 * NOTE: the exact `account_type` value for Builder accounts is assumed to be 'builder';
 * verify against the dev API `subject` payload with the test Builder-owner account.
 *
 * subject.principal.user is expected to carry exactly one key/value pair; we inspect the
 * first value.
 */
export function isUsableBuilderPrincipal(subject) {
    const user = Object.values(subject?.principal?.user || {})[0];
    return Boolean(user?.account_id) && user?.account_type === 'builder';
}
